import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    yearField: {
      width: theme.spacing(15),
    },
    yearRange: {
      display: 'flex',
      alignItems: 'baseline',
    },
    rangeDivider: {
      padding: theme.spacing(0, 0.5),
    },
  };
};
